<div class="metrics-table-container">  
    <h5>By Reviewer</h5>
    <div class="table-data">
        <p-table
            [value]="qcTimePerUserItems"
            [scrollable]="true"
            [paginator]="true"
            [rows]="50"
            [rowsPerPageOptions]="[5, 10, 20, 50]"
            [loading]="(loading$ | async)"
        >
            <!-- Headers -->
            <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="fullName" pFrozenColumn>
                    <div class="custom-header" >
                        Reviewer
                      <p-sortIcon field="fullName"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="ordersReviewed">
                    <div class="custom-header" pTooltip="Total orders reviewed" tooltipPosition="top">
                      Orders
                      <p-sortIcon field="ordersReviewed"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="revisionRate">
                    <div class="custom-header" pTooltip="Class rejected Orders" tooltipPosition="top">
                      Revision Rate
                      <p-sortIcon field="revisionRate"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="clientRevisionRate">
                    <div class="custom-header" pTooltip="Client returned Orders" tooltipPosition="top">
                      Client RR
                      <p-sortIcon field="clientRevisionRate"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgInitialViolationsNotReviewed">
                    <div class="custom-header" pTooltip="Average first mins the order spent in review" tooltipPosition="top">
                      Init Mins in Review
                      <p-sortIcon field="avgInitialViolationsNotReviewed"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgInitialViolationsNotReviewed">
                    <div class="custom-header" pTooltip="Average first mins order waited before review" tooltipPosition="top">
                      Init Mins Waiting
                      <p-sortIcon field="avgInitialViolationsNotReviewed"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgInitialViolationsNotReviewed">
                    <div class="custom-header" pTooltip="Average first minutes actively spent working in order review" tooltipPosition="top">
                      Init Mins Active Work
                      <p-sortIcon field="avgInitialViolationsNotReviewed"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgInitialViolationsToCheck">
                    <div class="custom-header" pTooltip="Average of rules triggered per order" tooltipPosition="top">
                      Rules to Check
                      <p-sortIcon field="avgInitialViolationsToCheck"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgInitialViolationsFailed">
                    <div class="custom-header" pTooltip="Average number of triggered rules marked as failed by the user" tooltipPosition="top">
                      Rules Failed
                      <p-sortIcon field="avgInitialViolationsFailed"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgInitialViolationsNotReviewed">
                    <div class="custom-header" pTooltip="Average number of triggered rules unmarked by the user" tooltipPosition="top">
                      Rules Not Reviewed
                      <p-sortIcon field="avgInitialViolationsNotReviewed"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgMinutesInReview">
                    <div class="custom-header" pTooltip="Average time the order spent in review" tooltipPosition="top">
                     Next Mins in Review
                      <p-sortIcon field="avgMinutesInReview"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgMinutesWaitingForReview">
                    <div class="custom-header" pTooltip="Average time order waited before review" tooltipPosition="top">
                     Next Mins Waiting
                      <p-sortIcon field="avgMinutesWaitingForReview"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="avgMinutesActiveWorkInReview">
                    <div class="custom-header" pTooltip="Average minutes actively spent working in order review" tooltipPosition="top">
                      Next Mins Active Work
                      <p-sortIcon field="avgMinutesActiveWorkInReview"></p-sortIcon>
                    </div>
                  </th>
                </tr>
              </ng-template>

            <!-- Rows -->
            <ng-template pTemplate="body" let-user>
                <tr>
                    <td pFrozenColumn><strong>{{ user.fullName }}</strong></td>
                    <td>{{ user.totalReviewed }} </td>
                    <td>{{ user.revisionRate }}%</td>
                    <td>{{ user.clientRevisionRate }}%</td>
                    <td>{{ user.avgMinutesInReviewInitial }}</td>
                    <td>{{ user.avgMinutesWaitingForReviewInitial }}</td>
                    <td>{{ user.avgMinutesActiveWorkInReviewInitial }}</td>
                    <td>{{ user.avgInitialViolationsToCheck }}</td>
                    <td>{{ user.avgInitialViolationsFailed }}</td>
                    <td>{{ user.avgInitialViolationsNotReviewed }}</td>
                    <td>{{ user.avgMinutesInReview }}</td>
                    <td>{{ user.avgMinutesWaitingForReview }}</td>
                    <td>{{ user.avgMinutesActiveWorkInReview }}</td>
                </tr>
            </ng-template>

              <!-- Main Footer for the averages values -->
            <ng-template pTemplate="footer">
                <tr>
                <td pFrozenColumn >Averages</td>
                <td>{{ getAverage('totalReviewed') }}</td>
                <td>{{ getAverage('revisionRate') }}%</td>
                <td>{{ getAverage('clientRevisionRate') }}%</td>
                <td>{{ getAverage('avgMinutesInReviewInitial') }}</td>
                <td>{{ getAverage('avgMinutesWaitingForReviewInitial') }}</td>
                <td>{{ getAverage('avgMinutesActiveWorkInReviewInitial') }}</td>
                <td>{{ getAverage('avgInitialViolationsToCheck') }}</td>
                <td>{{ getAverage('avgInitialViolationsFailed') }}</td>
                <td>{{ getAverage('avgInitialViolationsNotReviewed') }}</td>
                <td>{{ getAverage('avgMinutesInReview') }}</td>
                <td>{{ getAverage('avgMinutesWaitingForReview') }}</td>
                <td>{{ getAverage('avgMinutesActiveWorkInReview') }}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
                <button
                pButton
                label="Export .xls"
                icon="pi pi-file-excel"
                class="p-button-secondary p-button-outlined metric-table-custom-button"
                (click)="exportToExcel()"
              ></button>
            </ng-template>
        </p-table>
    </div>
</div>
